import {NavigationService} from "@/models/Menu/NavigationService";
import {MenuListRepository} from "@/models/Menu/MenuListRepository";

export class AxiosMenuListRepository extends MenuListRepository {
  static async getAll() {
    const menu = await NavigationService.find(process.env.VUE_APP_PRINCIPAL_MENU_ID);
    const routeItems = menu.items;

    return routeItems.map((routeNative) => {
      return this.toEntity(routeNative)
    });
  }
}
